import React, { useState, useEffect } from 'react'
import { Grid } from 'antd';
import InnerAppLayout from 'layouts/inner-app-layout';
import ChatMenu from './ChatMenu';
import ChatContent from './ChatContent';
import { LiveChatProvider } from './LiveChatContext';
import utils from 'utils';
import { useLocation } from 'react-router-dom';

const { useBreakpoint } = Grid;

const LiveChat = props => {
	const [menuState, setMenuState] = useState();
	const location = useLocation();
	// Derive whether a chat is open from the URL — /chats/<number>
	const chatId = location.pathname.match(/\/chats\/(\S+)/)?.[1];
	const [mobileView, setMobileView] = useState(chatId ? 'chat' : 'list');
	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');

	// Sync view with URL — back arrow navigates to /chats
	useEffect(() => {
		setMobileView(chatId ? 'chat' : 'list');
	}, [chatId]);

	// Lock the page body immediately on mobile to prevent iOS Safari
	// from scrolling the whole page when navigating to a chat.
	useEffect(() => {
		if (!isMobile) {
			return undefined;
		}

		// Save current scroll position before locking
		const scrollY = window.scrollY || window.pageYOffset || 0;

		// Apply lock immediately
		document.body.classList.add('chat-mobile-page');
		document.body.style.top = `-${scrollY}px`;

		// Also force-reset scroll in the next frame in case the browser
		// already started scrolling before the lock kicked in
		const frameId = window.requestAnimationFrame(() => {
			window.scrollTo(0, 0);
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
		});

		return () => {
			window.cancelAnimationFrame(frameId);
			document.body.classList.remove('chat-mobile-page');
			document.body.style.top = '';
			// Restore scroll position when leaving chat
			window.scrollTo(0, scrollY);
		};
	}, [isMobile, mobileView, chatId]);

	const handleChatOpen = () => setMobileView('chat');

	if (isMobile) {
		return (
			<LiveChatProvider>
				<div className="chat chat-mobile-shell">
					{mobileView === 'list' ? (
						<ChatMenu
							{...props}
							setMenuState={setMenuState}
							onChatOpen={handleChatOpen}
						/>
					) : (
						<ChatContent
							{...props}
							menuState={menuState}
						/>
					)}
				</div>
			</LiveChatProvider>
		);
	}

	return (
		<LiveChatProvider>
			<div className="chat">
				<InnerAppLayout
					sideContent={<ChatMenu {...props} setMenuState={setMenuState} />}
					mainContent={<ChatContent {...props} menuState={menuState} />}
					sideContentWidth={480}
					sideContentGutter={false}
					border
				/>
			</div>
		</LiveChatProvider>
	)
}

export default LiveChat
